import http from "@/utils/request";
import qs from "qs";
import { uploadImageToQiniu } from "@/api/qiniuUpload";

export { getQnyToken } from "@/api/qiniuUpload";

// 实例POST接口
export function examplePost(data) {
  return http.request({
    url: "/api/examplePost",
    method: "POST",
    data,
  });
}

// 实例GET接口
export function examplePostGet(data) {
  return http.request({
    url: "/api/examplePostGet?" + qs.stringify(data),
    method: "GET",
  });
}

// /exchange/rate/query
export function exchangeRateQuery(data) {
  return http.request({
    url: "/api/paipika-service/exchange/rate/query",
    method: "POST",
    data,
  });
}
//下一次团发时间
/**
 *
 * @param {
 * nextTourTime:string,年月日时分秒
 * } data
 * @returns
 */
export function nextTourTime(data) {
  return http.request({
    url: "/api/paipika-service/usercoupons/nextTourTime",
    method: "POST",
    data,
  });
}

// /exchange/rate/update
export function exchangeRateUpdate(data) {
  return http.request({
    url: "/api/paipika-service/exchange/rate/update",
    method: "POST",
    data,
  });
}

// 发送还价消息
export function counterOfferMessageSend(data) {
  return http.request({
    url: "/api/manager-service/counterOffer/message/send",
    method: "POST",
    data,
  });
}

// 更新卖家已发货状态
export function orderItemStatusShipped(data) {
  return http.request({
    url: "/api/manager-service/orderItem/status/shipped",
    method: "POST",
    data,
  });
}
// 设置国内快递单号
export function setTrackingNo(data) {
  return http.request({
    url: "/api/manager-service/mail/trackingNo/domestic/set",
    method: "POST",
    data,
  });
}

// 发送还价订单购买结果
export function counterOfferResultSend(data) {
  return http.request({
    url: "/api/manager-service/counterOffer/result/send",
    method: "POST",
    data,
  });
}

// 条件分页查询还价订单信息
export function counterOfferQueryPageConditional(data) {
  return http.request({
    url: "/api/manager-service/counterOffer/query/page/conditional",
    method: "POST",
    data,
  });
}
// 确认还价订单退款
export function counterOfferRefundConfirm(data) {
  return http.request({
    url: "/api/manager-service/counterOffer/refund/confirm",
    method: "POST",
    data,
  });
}

// 创建优惠券接口
export function createCoupon(data) {
  return http.request({
    url: "/api/manager-service/coupon/create",
    method: "POST",
    data,
  });
}
//
export function couponQuery(data) {
  return http.request({
    url: "/api/manager-service/coupon/query",
    method: "POST",
    data,
  });
}

// 搜索优惠券 /coupon/tip
export function couponTip(data) {
  return http.request({
    url: "/api/manager-service/coupon/tip",
    method: "POST",
    data,
  });
}
// 发送优惠券接口
export function sendCoupon(data) {
  return http.request({
    url: "/api/manager-service/coupon/send",
    method: "POST",
    data,
  });
}

// 批量发放优惠券
export function batchSend(data) {
  return http.request({
    url: "/api/manager-service/coupon/batch/send",
    method: "POST",
    data,
  });
}

// 删除优惠券
export function deleteCoupon(data) {
  return http.request({
    url: "/api/manager-service/coupon/delete",
    method: "POST",
    data,
  });
}
// 编辑优惠券
export function editCoupon(data) {
  return http.request({
    url: "/api/manager-service/coupon/edit",
    method: "POST",
    data,
  });
}

// 用户登录 userLogin
export function userLogin(data) {
  return http.request({
    url: "/api/user-service/manager/login/account",
    method: "POST",
    whiteUrl: true,
    data,
  });
}
// 登录验证码
export function generateImageCode() {
  return http.request({
    url: "/api/user-service/user/generateImageCode",
    method: "GET",
    whiteUrl: true,
  });
}

// 查询用户数据
export function getUserList(data) {
  return http.request({
    url: "/api/manager-service/user/query",
    method: "POST",
    data,
  });
}

// 封号解封
export function changeStatus(data) {
  return http.request({
    url: "/api/manager-service/user/status/update",
    method: "POST",
    data,
  });
}
// 用户邀请好友数据分页
export function getInvitedFriends(data) {
  return http.request({
    url: "/api/manager-service/user/invitor/query/page",
    method: "POST",
    data,
  });
}
// 历史订单 queryOrder
export function queryOrder(data) {
  return http.request({
    url: "/api/manager-service/order/item/query",
    method: "POST",
    data,
  });
}

// 历史订单 queryOrder
export function waitReceive(data) {
  return http.request({
    url: "/api/manager-service/orderItem/query/page/waitReceive",
    method: "POST",
    data,
  });
}
// /orderItem/confirm
export function confirmOrder(data) {
  return http.request({
    url: "/api/manager-service/orderItem/confirm",
    method: "POST",
    data,
  });
}
// 会员数据/experience/page
export function getMemberList(data) {
  return http.request({
    url: "/api/manager-service/experience/page",
    method: "POST",
    data,
  });
}

// 优惠券分页
export function getCouponList(data) {
  return http.request({
    url: "/api/manager-service/user/coupon/page",
    method: "POST",
    data,
  });
}

// Apifox: 449329198 / 253200290；原始预选 shippingInsuranceServiceId 与实际保单 insuranceServices 分开展示。
export function getMailQueryPage(data) {
  return http.request({
    url: "/api/manager-service/mail/query/page",
    method: "POST",
    data,
  });
}
//
export function mailPackage(data) {
  return http.request({
    url: "/api/manager-service/mail/package",
    method: "POST",
    data,
  });
}

// 修改或补填合包包裹号，不改变状态或重新通知用户。
export function updateMailPackageNo(data) {
  return http.request({
    url: "/api/manager-service/mail/packageNo/update",
    method: "POST",
    data,
  });
}

export function outBound(data) {
  return http.request({
    url: "/api/manager-service/orderItem/outBound",
    method: "POST",
    data,
  });
}

// /mail/send/batch
export function sendMail(data) {
  return http.request({
    url: "/api/manager-service/mail/send/batch",
    method: "POST",
    data,
  });
}

// 创建轮播图
export function createCarouselImage(data) {
  return http.request({
    url: "/api/manager-service/carouselImage/create",
    method: "POST",
    data,
  });
}
// 推送购买结果
export function orderItemResultPush(data) {
  return http.request({
    url: "/api/manager-service/orderItem/result/push",
    method: "POST",
    data,
  });
}

// 中断自动收货
export function orderItemConfirmStop(data) {
  return http.request({
    url: "/api/manager-service/orderItem/confirm/stop",
    method: "POST",
    data,
  });
}

// 删除轮播图
export function deleteCarouselImage(data) {
  return http.request({
    url: "/api/manager-service/carouselImage/delete",
    method: "POST",
    data,
  });
}
// 查询轮播图
export function queryCarouselImage(data) {
  return http.request({
    url: "/api/manager-service/carouselImage/query/all?" + qs.stringify(data),
    method: "GET",
  });
}

// 更新轮播图顺序
export function updateCarouselImageOrder(data) {
  return http.request({
    url: "/api/manager-service/carouselImage/order/update",
    method: "POST",
    data,
  });
}

// 订单入库
export function storeOrderItem(data) {
  return http.request({
    url: "/api/manager-service/orderItem/store",
    method: "POST",
    data,
  });
}

// 订单状态下拉框数据
export function getOrderStatus() {
  return http.request({
    url: "/order-service/order/manager/orderStatus",
    method: "GET",
  });
}

// 来源列表
export function getGoodsType() {
  return http.request({
    url: "/order-service/order/manager/goodsType",
    method: "GET",
  });
}

// 获取会员等级 getUserLevel
export function getUserLevel() {
  return http.request({
    url: "/user-service/user/manager/userLevel",
    method: "GET",
  });
}
// 批量发送消息
export function sendMessage(data) {
  return http.request({
    url: "/api/manager-service/message/send/batch",
    method: "POST",
    data,
  });
}
//全部送消息
export function sendMessageConditional(data) {
  return http.request({
    url: "/api/manager-service/message/send/conditional",
    method: "POST",
    data,
  });
}

// 批量发放积分
export function sendPoints(data) {
  return http.request({
    url: "/api/manager-service/points/send/batch",
    method: "POST",
    data,
  });
}

// 积分明细
export function pointsDetail(data) {
  return http.request({
    url: "/api/manager-service/points/usage/page",
    method: "POST",
    data,
  });
}

// /修改会员等级信息
/***
 * 修改会员等级信息
 * @param {userIds:[]} 用户id
 * @param {experience:number} 经验改动支持正负值
 * @param {level:number} 等级改动支持正负值
 * @returns
 */
export function modifyMember(data) {
  return http.request({
    url: "/api/manager-service/user/member/modify",
    method: "POST",
    data,
  });
}

// 邀请好友状态修改
export function updateInvited(data) {
  return http.request({
    url: "/api/manager-service/user/relation/unbind",
    method: "POST",
    data,
  });
}

// 查询分类列表
export function getCategoryList(data) {
  return http.request({
    url: "/api/manager-service/category/query",
    method: "POST",
    data,
  });
}

// 创建分类
export function createCategory(data) {
  return http.request({
    url: "/api/manager-service/category/create",
    method: "POST",
    data,
  });
}

// 删除分类
export function deleteCategory(data) {
  return http.request({
    url: "/api/manager-service/category/delete",
    method: "POST",
    data,
  });
}
// 复制一级分类
export function copyCategory(data) {
  return http.request({
    url: "/api/manager-service/category/copy",
    method: "POST",
    data,
  });
}
// 编辑分类
/**
 *
 * @param {
 * id: number,分类ID 必选
 * category: string,分类名称 可选
 * categoryReal: string,分类名称 可选
 * categoryImage: string,分类图片 可选
 * categoryNo: string,分类编号 可选
 * } data
 * @returns
 */
export function editCategory(data) {
  return http.request({
    url: "/api/manager-service/category/edit",
    method: "POST",
    data,
  });
}

// 移动分类
/**
 *
 * @param {
 * idList: [],移动分类id集合
 * parentId: number,移动到的父级分类id
 * } data
 * @returns
 */
export function moveCategory(data) {
  return http.request({
    url: "/api/paipika-service/category/move",
    method: "POST",
    data,
  });
}

// 七牛加速直传，兼容原上传表单和业务响应。
export function uploadQiniu(data, onUploadProgress) {
  return uploadImageToQiniu(data, onUploadProgress);
}

// 更新订单售后状态
export function updateOrderSaleStatus(data) {
  return http.request({
    url: "/api/manager-service/orderItem/update/orderSaleStatus",
    method: "POST",
    data,
  });
}

// 修改合包状态
export function updateMailStatus(data) {
  return http.request({
    url: "/api/manager-service/mail/status/update",
    method: "POST",
    data,
  });
}

// 添加入库图片
export function addStorageImages(data) {
  return http.request({
    url: "/api/manager-service/orderItem/addStoreImg",
    method: "POST",
    data,
  });
}

// 删除入库图片
export function deleteStorageImages(data) {
  return http.request({
    url: "/api/manager-service/orderItem/deleStoreImg",
    method: "POST",
    data,
  });
}

// 修改合包信息
export function fetchMailPackageModify(data) {
  return http.request({
    url: "/api/manager-service/mail/package/modify",
    method: "POST",
    data,
  });
}

// 合包回退
export function fetchMailRollback(data) {
  return http.request({
    url: "/api/manager-service/mail/rollback",
    method: "POST",
    data,
  });
}

// 保存留言内容
export function fetchMailBackendMessage(data) {
  return http.request({
    url: "/api/manager-service/mail/backendMessage/save",
    method: "POST",
    data,
  });
}

// 打印订单
export function fetchPrintOrderItem(data) {
  return http.request({
    url: "/api/manager-service/orderItem/print",
    method: "POST",
    data,
  });
}

// 保存合包图片
export function saveMailPackageImage(data) {
  return http.request({
    url: "/api/manager-service/mail/image/save",
    method: "POST",
    data,
  });
}
// 删除合包图片
export function deleteMailPackageImage(id) {
  return http.request({
    url: `/api/manager-service/mail/image/${id}`,
    method: "DELETE",
  });
}
